import { render } from "./custom-select.vue?vue&type=template&id=738a8ae4&ts=true"
import script from "./custom-select.ts?vue&type=script&lang=ts&external"
export * from "./custom-select.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__